(function($, undefined) {
	'use strict';
	var utils;

	var init = function() {
		let $tabs = $('.tabs');

		utils = Fw.component.models().utils;

		$('.tabs__tab').on('click', onTabClick);
		$('.tabs-container__overflow-arrow').on('click', onOverflowArrowClick);

		$tabs.on('scroll', onTabsScroll);
		$tabs.trigger("scroll");

		if ($tabs.length) {
			$(window).on('resize', () => {
				$tabs.trigger("scroll");
			});
		}

		verifyDisabledFirstTabs();
	};

	function onTabClick({ currentTarget }) {
		var tab = $(currentTarget);
		var urlParam = tab.attr("data-url-param");
		var id = tab.attr("data-id");
		var disabled = tab.hasClass("tabs__tab_disabled");

		if (id && !disabled && !tab.hasClass("tabs__tab_selected")) {
			$('.tabs__tab_selected[data-url-param=' + urlParam + ']').removeClass("tabs__tab_selected");
			tab.addClass("tabs__tab_selected");

			$('.tab-content_selected[data-url-param=' + urlParam + ']').removeClass("tab-content_selected");
			$('.tab-content[data-url-param=' + urlParam + '][data-id=' + id + ']').addClass("tab-content_selected");

			utils.addOrReplaceParam(urlParam, id, true);
		}

		if (tab.hasClass('tabs__tab_display-block') && utils.isSM()) {
			var target = $('.tab-content_selected').offset().top;
			if ($(window).scrollTop() > target) {
				target = target - $('.site-header__bottom').outerHeight();
			}
			$('html').animate({ scrollTop: target }, 500);
			$('body').animate({ scrollTop: target }, 500);
		}
	}

	function onOverflowArrowClick({ currentTarget }) {
		var arrow = $(currentTarget);
		var container = arrow.closest(".tabs-container");
		var scrollingTabs = $('.tabs', container);
		var currentScrollLeft = scrollingTabs.get(0).scrollLeft;

		var offset = 100;
		if (arrow.hasClass("tabs-container__overflow-arrow_left")) {
			offset *= -1;
		}
		scrollingTabs.animate({scrollLeft: currentScrollLeft + offset}, 300);

	}

	function onTabsScroll({ currentTarget }) {
		var t = currentTarget;
		var $t = $(currentTarget);
		var container = $t.closest(".tabs-container");
		var isAtTheEndOfScroll = t.scrollLeft + t.clientWidth >= t.scrollWidth;
		var isAtStartOfScroll = t.scrollLeft <= 0;

		container.toggleClass("tabs-container_overflow-right", !isAtTheEndOfScroll);
		container.toggleClass("tabs-container_overflow-left", !isAtStartOfScroll);
	}

	function verifyDisabledFirstTabs() {
		$('.tabs-container').each(function(i, el) {
			if ($('.tabs__tab_selected', el).hasClass("tabs__tab_disabled")) {
				var firstNotDisabledTab = $('.tabs__tab:not(.tabs__tab_disabled)', el).first();
				firstNotDisabledTab.click();
			}
		});
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
